import { all, takeEvery, put, fork, call, select } from 'redux-saga/effects';
import { message } from 'antd';
import actions from './actions';
import { ApiClient } from '../../../api';
import { makeSelectToken } from '../../auth/selector';
import config from '../../../settings';

// Create selector once for optimal performance
const selectToken = makeSelectToken();

function* getRoleTemplatesSaga() {
  yield takeEvery(actions.GET_ROLE_TEMPLATES, function*() {
    try {
      // Use idToken for Super Admin operations (role templates management)
      const idToken = yield select(selectToken);
      const apiClient = new ApiClient(config.apiUrl, idToken);
      const response = yield call(() => apiClient.getRoleTemplates());
      if (response.success) {
        yield put(actions.getRoleTemplatesSuccess(response.data));
      } else {
        yield put(actions.getRoleTemplatesError(response.message || 'Failed to fetch role templates'));
        message.error('Failed to fetch role templates');
      }
    } catch (error) {
      yield put(actions.getRoleTemplatesError(error.message));
      message.error(`Error fetching role templates: ${error.message}`);
    }
  });
}

function* createRoleTemplateSaga() {
  yield takeEvery(actions.CREATE_ROLE_TEMPLATE, function*({ templateData }) {
    try {
      // Use idToken for Super Admin operations (role templates management)
      const idToken = yield select(selectToken);
      const apiClient = new ApiClient(config.apiUrl, idToken);
      const response = yield call(() => apiClient.createRoleTemplate(templateData));
      if (response.success) {
        yield put(actions.createRoleTemplateSuccess(response.data));
        message.success('Role template created successfully');
      } else {
        yield put(actions.createRoleTemplateError(response.message || 'Failed to create role template'));
        message.error('Failed to create role template');
      }
    } catch (error) {
      yield put(actions.createRoleTemplateError(error.message));
      message.error(`Error creating role template: ${error.message}`);
    }
  });
}

function* updateRoleTemplateSaga() {
  yield takeEvery(actions.UPDATE_ROLE_TEMPLATE, function*({ templateId, templateData }) {
    try {
      // Use idToken for Super Admin operations (role templates management)
      const idToken = yield select(selectToken);
      const apiClient = new ApiClient(config.apiUrl, idToken);
      const response = yield call(() => apiClient.updateRoleTemplate(templateId, templateData));
      if (response.success) {
        yield put(actions.updateRoleTemplateSuccess(response.data));
        message.success('Role template updated successfully');
      } else {
        yield put(actions.updateRoleTemplateError(response.message || 'Failed to update role template'));
        message.error('Failed to update role template');
      }
    } catch (error) {
      yield put(actions.updateRoleTemplateError(error.message));
      message.error(`Error updating role template: ${error.message}`);
    }
  });
}

function* deleteRoleTemplateSaga() {
  yield takeEvery(actions.DELETE_ROLE_TEMPLATE, function*({ templateId }) {
    try {
      // Use idToken for Super Admin operations (role templates management)
      const idToken = yield select(selectToken);
      const apiClient = new ApiClient(config.apiUrl, idToken);
      const response = yield call(() => apiClient.deleteRoleTemplate(templateId));
      if (response.success) {
        yield put(actions.deleteRoleTemplateSuccess(templateId));
        message.success('Role template deleted successfully');
      } else {
        yield put(actions.deleteRoleTemplateError(response.message || 'Failed to delete role template'));
        message.error('Failed to delete role template');
      }
    } catch (error) {
      yield put(actions.deleteRoleTemplateError(error.message));
      message.error(`Error deleting role template: ${error.message}`);
    }
  });
}

export default function* roleTemplatesSaga() {
  yield all([
    fork(getRoleTemplatesSaga),
    fork(createRoleTemplateSaga),
    fork(updateRoleTemplateSaga),
    fork(deleteRoleTemplateSaga),
  ]);
}
